import LoginTemplate from '../../templates/login-template/loginTemplate';

function Login(props) {
    return (        
        <LoginTemplate isAuthed={props.isAuthed}/>
    );
}

export default Login;